export const state = () => ({
    showPrompt: true,
});
